import { Button, ButtonGroup, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SectionSeparator from "../SectionSeparator";

const ClinicInformationStep = ({ ctx }) => {
  const {
    formData,
    errors,
    handleChange,
    handleButtonClick,
    otherAllergiesButtonValue,
  } = ctx;

  return (
    <>
      <SectionSeparator title="title.food_other_allergy" />
      <Row>
        <Col md={12} className="mb-4">
          <Row>
            <Col md={2}>
              <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                <FormattedMessage id="known_allergies" />
              </Form.Label>
            </Col>
            <Col md={1} style={{ paddingTop: 3 }}>
              <ButtonGroup className="mx-3">
                <Button
                  size="sm"
                  name="leela_allergies_button"
                  value="Yes"
                  variant={
                    otherAllergiesButtonValue.leela_allergies_button === "Yes"
                      ? "secondary"
                      : "light"
                  }
                  onClick={handleButtonClick}
                >
                  <FormattedMessage id="yes" />
                </Button>
                <Button
                  size="sm"
                  name="leela_allergies_button"
                  value="No"
                  variant={
                    otherAllergiesButtonValue.leela_allergies_button === "No"
                      ? "secondary"
                      : "light"
                  }
                  onClick={handleButtonClick}
                >
                  <FormattedMessage id="no" />
                </Button>
              </ButtonGroup>
            </Col>
            <Col md={9} className="ps-4">
              <Form.Group className="mb-4 position-relative">
                {otherAllergiesButtonValue.leela_allergies_button === "Yes" && (
                  <FormattedMessage id="if_yes_please_specify">
                    {(placeholder) => (
                      <Form.Control
                        value={formData.leela_allergies}
                        placeholder={placeholder}
                        type="text"
                        name="leela_allergies"
                        onChange={handleChange}
                        isInvalid={!!errors.leela_allergies}
                      />
                    )}
                  </FormattedMessage>
                )}
                <Form.Control.Feedback className="px-3" type="invalid">
                  <FormattedMessage id="error.leela_allergies" />
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Col>
        <Col md={12} className="mb-4">
          <Row>
            <Col md={2}>
              <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                <FormattedMessage id="dietary_intolerance" />
              </Form.Label>
            </Col>
            <Col md={1} style={{ paddingTop: 3 }}>
              <ButtonGroup className="mx-3">
                <Button
                  size="sm"
                  name="leela_dietry_intolerances_button"
                  onClick={handleButtonClick}
                  value="Yes"
                  variant={
                    otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                    "Yes"
                      ? "secondary"
                      : "light"
                  }
                >
                  <FormattedMessage id="yes" />
                </Button>
                <Button
                  size="sm"
                  name="leela_dietry_intolerances_button"
                  onClick={handleButtonClick}
                  value="No"
                  variant={
                    otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                    "No"
                      ? "secondary"
                      : "light"
                  }
                >
                  <FormattedMessage id="no" />
                </Button>
              </ButtonGroup>
            </Col>
            <Col md={9} className="ps-4">
              <Form.Group className="mb-4 position-relative">
                {otherAllergiesButtonValue.leela_dietry_intolerances_button ===
                  "Yes" && (
                  <FormattedMessage id="if_yes_please_specify">
                    {(placeholder) => (
                      <Form.Control
                        value={formData.leela_dietry_intolerances}
                        placeholder={placeholder}
                        type="text"
                        name="leela_dietry_intolerances"
                        onChange={handleChange}
                        isInvalid={!!errors.leela_dietry_intolerances}
                      />
                    )}
                  </FormattedMessage>
                )}
                <Form.Control.Feedback className="px-3" type="invalid">
                  <FormattedMessage id="error.leela_dietry_intolerances" />
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Col>
        <Col md={12} className="mb-4">
          <Row>
            <Col md={2}>
              <Form.Label style={{ paddingTop: 3, marginBottom: 11 }}>
                <FormattedMessage id="special_requirements" />
              </Form.Label>
            </Col>
            <Col md={1} style={{ paddingTop: 3 }}>
              <ButtonGroup className="mx-3">
                <Button
                  size="sm"
                  name="leela_special_req_button"
                  onClick={handleButtonClick}
                  value="Yes"
                  variant={
                    otherAllergiesButtonValue.leela_special_req_button === "Yes"
                      ? "secondary"
                      : "light"
                  }
                >
                  <FormattedMessage id="yes" />
                </Button>
                <Button
                  size="sm"
                  name="leela_special_req_button"
                  onClick={handleButtonClick}
                  value="No"
                  variant={
                    otherAllergiesButtonValue.leela_special_req_button === "No"
                      ? "secondary"
                      : "light"
                  }
                >
                  <FormattedMessage id="no" />
                </Button>
              </ButtonGroup>
            </Col>
            <Col md={9} className="ps-4">
              <Form.Group className="mb-4 position-relative">
                {otherAllergiesButtonValue.leela_special_req_button ===
                  "Yes" && (
                  <FormattedMessage id="if_yes_please_specify">
                    {(placeholder) => (
                      <Form.Control
                        value={formData.leela_special_req}
                        placeholder={placeholder}
                        type="text"
                        name="leela_special_req"
                        onChange={handleChange}
                        isInvalid={!!errors.leela_special_req}
                      />
                    )}
                  </FormattedMessage>
                )}
                <Form.Control.Feedback className="px-3" type="invalid">
                  <FormattedMessage id="error.leela_special_req" />
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <div className="max-w-2xl mx-auto p-6">
            <div className="mb-4">
              <h5 className="font-semibold">1. Emergency Response Contact:</h5>
              <p className="text-gray-700">
                I understand that MLS may contact emergency services by dialing{" "}
                <strong>997</strong> to arrange for immediate transportation to
                the nearest hospital for my child in the event of a medical
                emergency.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="font-semibold">2. Swift Action:</h5>
              <p className="text-gray-700">
                I acknowledge that MLS will take prompt and necessary actions to
                ensure the health and well-being of my child during a medical
                emergency. This may include contacting emergency services
                without delay.
              </p>
            </div>

            <div className="mb-4">
              <h5 className="font-semibold">
                3. Communication with Parent/Guardian:
              </h5>
              <p className="text-gray-700">
                While MLS will make reasonable efforts to contact me or the
                designated emergency contact person provided in my child's
                emergency contact form, I recognize that immediate action may be
                required to secure the safety of my child.
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <SectionSeparator title="title.other_allergy" />
      <Row>
        <Col md={12}>
          <Form.Group className="mb-4">
            <Form.Label>
              <FormattedMessage id="medicines" />
            </Form.Label>
            <Form.Control
              value={formData.medicines}
              type="text"
              name="medicines"
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group className="mb-4">
            <Form.Label>
              <FormattedMessage id="allergies" />
            </Form.Label>
            <Form.Control
              value={formData.allergies}
              type="text"
              name="allergies"
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
        <Col md={12}>
          <Form.Group className="mb-4">
            <Form.Label>
              <FormattedMessage id="allergic_reactions" />
            </Form.Label>
            <Form.Control
              value={formData.allergic_reactions}
              type="text"
              name="allergic_reactions"
              onChange={handleChange}
            />
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default ClinicInformationStep;
